import axios from 'axios'
import {
  GET_ARCHIVED_CLIENTS_COUNT,
  GET_ARCHIVED_CLIENTS_LIST,
  GET_ARCHIVED_CLIENT,
  ARCHIVE_CLIENT
} from './action-constants'

const TABLENAME = 'archivedclients'
const TABLENAME_BY_LOGIN_ID =
  'archivedclients/bylogin' /*** ROUTE UPDATED TO ADD SECURITY MEASURES */
const TABLENAME_CLIENT_ARCHIVE_CLIENT = 'clients/archive'
const TABLENAME_CLIENT_COUNT = 'archivedclients/count'

export function getArchivedClientsCount (loginID) {
  const JSONURL = process.env.REACT_APP_DATABASE_URL + '/' + TABLENAME_CLIENT_COUNT + '/' + loginID
  return {
    type: GET_ARCHIVED_CLIENTS_COUNT,
    payload: new Promise((resolve, reject) => {
      axios
        .get(JSONURL)
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  }
}

export function getArchivedClientsList (loginID) {
  const JSONURL = process.env.REACT_APP_DATABASE_URL + '/' + TABLENAME_BY_LOGIN_ID + '/' + loginID
  return {
    type: GET_ARCHIVED_CLIENTS_LIST,
    payload: new Promise((resolve, reject) => {
      axios
        .get(JSONURL)
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  }
}

export function getArchivedClient (id) {
  const JSONURL = process.env.REACT_APP_DATABASE_URL + '/' + TABLENAME + '/' + id
  return {
    type: GET_ARCHIVED_CLIENT,
    payload: new Promise((resolve, reject) => {
      axios
        .get(JSONURL)
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  }
}

export function archiveClient (id, params) {
  const JSONURL = process.env.REACT_APP_DATABASE_URL + '/' + TABLENAME_CLIENT_ARCHIVE_CLIENT + '/' + id
  return {
    type: ARCHIVE_CLIENT,
    payload: new Promise((resolve, reject) => {
      axios
        .post(JSONURL, params)
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  }
}
